module.exports = __webpack_public_path__ + "static/media/bwbclogo.2621c19a.png";